import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';  // FIXED: Add useLocation for state.from

// project imports
import useAuth from 'hooks/useAuth';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 * @param {boolean} [adminOnly=false] Require admin role
 */
export default function AuthGuard({ children, adminOnly = false }) {
  const { isAuthenticated, user } = useAuth();  // FIXED: Use isAuthenticated (from context); add user for role check
  const location = useLocation();

  // FIXED: Conditional render—no useEffect (immediate, no flicker)
  if (!isAuthenticated) {
    // Redirect to login, preserve intended path
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && user?.role !== 'admin') {
    // FIXED: Role guard—redirect non-admins to safe page (e.g., bookings)
    return <Navigate to="/bookings" state={{ from: location }} replace />;
  }

  return children;
}

AuthGuard.propTypes = { 
  children: PropTypes.node,  // FIXED: Use PropTypes.node for accuracy
  adminOnly: PropTypes.bool 
};